import { isHiddenInMvp } from "@/shared/lib/launch-mode";

/**
 * Раздел личных сообщений. Один и тот же путь гейтит и сам виджет чата
 * (`<ChatWidgetRoot />` в root-content), и все кнопки «Написать».
 */
export const CHAT_ROUTE = "/messages";

/**
 * Доступен ли чат. Единственный признак — открыт ли раздел `/messages`
 * (`MVP_HIDDEN_ROUTE_PREFIXES` в `shared/lib/launch-mode.ts`).
 *
 * Смысл: включение чата = удаление одной строки из этого списка. Кнопка
 * «Написать» и окно переписки появляются вместе, поэтому невозможно состояние
 * «кнопка есть, а нажатие ничего не делает».
 */
export function isChatAvailable(): boolean {
  return !isHiddenInMvp(CHAT_ROUTE);
}
